export default __webpack_public_path__ + "static/media/icon-joinnow.b71b20ca.svg";